module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loaded) ? _c('div', {
    staticClass: "col-md-12 people-reach"
  }, [_c('h6', [_vm._v(_vm._s(_vm.audienceTitle) + ":")]), _c('package-slider', {
    attrs: {
      "packages": _vm.packagesArr,
      "selected": _vm.campaign.package,
      "useBudget": _vm.offerByBudget(_vm.campaign.goal_type)
    },
    on: {
      "update:selected": function($event) {
        _vm.campaign.package = $event
      }
    }
  }), (_vm.isLeadCampaign) ? _c('div', {
    staticClass: "mt-2"
  }, [(_vm.offerByBudget('lead_generation')) ? [(_vm.estimatedClicks.min > 0 || _vm.estimatedClicks.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.clicks', _vm.estimatedClicks)))]) : _vm._e(), (_vm.estimatedLeads.min > 0 || _vm.estimatedLeads.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.leads', _vm.estimatedLeads)))]) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.lead-generation', {
    reach: _vm.selectedPackage.reach.min,
    context: _vm.campaign.mode
  })))])] : [(_vm.estimatedClicks.min > 0 || _vm.estimatedClicks.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.clicks', _vm.estimatedClicks)))]) : _vm._e(), (_vm.estimatedLeads.min > 0 || _vm.estimatedLeads.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.leads', _vm.estimatedLeads)))]) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.lead-generation', {
    reach: _vm.selectedPackage.reach.min,
    context: _vm.campaign.mode
  })))]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.price', {
    price: _vm.selectedPackage.budget.budget,
    context: _vm.campaign.mode
  })))]), (!_vm.isOneoffCampaign && _vm.campaign.details.duration) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.total-price', {
    price: _vm.selectedPackage.budget.budget * _vm.campaign.details.duration
  })))]) : _vm._e()], (_vm.$t('pos.offer.extraline').length) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.extraline')))]) : _vm._e()], 2) : _vm._e(), (_vm.isClicksCampaign) ? _c('div', {
    staticClass: "mt-2"
  }, [(_vm.offerByBudget('reach_and_click')) ? [(_vm.estimatedClicks.min > 0 || _vm.estimatedClicks.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.clicks', _vm.estimatedClicks)))]) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.reach-and-click', {
    reach: _vm.selectedPackage.reach.min,
    context: _vm.campaign.mode
  })))])] : [(_vm.estimatedClicks.min > 0 || _vm.estimatedClicks.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.clicks', _vm.estimatedClicks)))]) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.reach-and-click', {
    reach: _vm.selectedPackage.reach.min,
    context: _vm.campaign.mode
  })))]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.price', {
    price: _vm.selectedPackage.budget.budget,
    context: _vm.campaign.mode
  })))]), (!_vm.isOneoffCampaign && _vm.campaign.details.duration) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.total-price', {
    price: _vm.selectedPackage.budget.budget * _vm.campaign.details.duration
  })))]) : _vm._e()], (_vm.$t('pos.offer.extraline').length) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.extraline')))]) : _vm._e()], 2) : _vm._e(), (_vm.isReachCampaign) ? _c('div', {
    staticClass: "mt-2"
  }, [(!_vm.isOneoffCampaign && _vm.campaign.details && _vm.campaign.details.duration) ? [(_vm.currentCluster) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.reach-total', {
    reach: _vm.selectedPackage.reach.min * _vm.currentCluster.reachDivider
  })))]) : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.reach-frequency', {
    users: _vm.selectedPackage.reach.min,
    frequency: _vm.selectedPackage.frequency,
    context: _vm.campaign.mode
  })))]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.price', {
    price: _vm.selectedPackage.budget.budget,
    context: _vm.campaign.mode
  })))]), (!_vm.isOneoffCampaign && _vm.campaign.details.duration) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.total-price', {
    price: _vm.selectedPackage.budget.budget * _vm.campaign.details.duration
  })))]) : _vm._e(), (_vm.offerByBudget('reach_frequency') || _vm.offerByBudget('post_engagement')) ? void 0 : void 0, (_vm.$t('pos.offer.extraline').length) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.extraline')))]) : _vm._e()], 2) : _vm._e(), (_vm.isOfferCampaign) ? _c('div', {
    staticClass: "mt-2"
  }, [(_vm.offerByBudget('local_offers')) ? [(_vm.estimatedClicks.min > 0 || _vm.estimatedClicks.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.clicks', _vm.estimatedClicks)))]) : _vm._e(), (_vm.estimatedOffers.min > 0 || _vm.estimatedOffers.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.offers', _vm.estimatedOffers)))]) : _vm._e(), _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.local-offers', {
    reach: _vm.selectedPackage.reach.min,
    context: _vm.campaign.mode
  })))])] : [(_vm.estimatedClicks.min > 0 || _vm.estimatedClicks.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.clicks', _vm.estimatedClicks)))]) : _vm._e(), (_vm.estimatedOffers.min > 0 || _vm.estimatedOffers.max > 0) ? _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.offers', _vm.estimatedOffers)))]) : _vm._e(), _c('div', {
    staticClass: "title title-clicks"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.local-offers', {
    reach: _vm.selectedPackage.reach.min,
    context: _vm.campaign.mode
  })))]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.price', {
    price: _vm.selectedPackage.budget.budget,
    context: _vm.campaign.mode
  })))]), (!_vm.isOneoffCampaign && _vm.campaign.details.duration) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.total-price', {
    price: _vm.selectedPackage.budget.budget * _vm.campaign.details.duration
  })))]) : _vm._e()], (_vm.$t('pos.offer.extraline').length) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.extraline')))]) : _vm._e()], 2) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bf97a22"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/package-slider-box/PackageSliderBox.vue
// module id = 914
// module chunks = 1